import { CompanyReportState } from './types-store';
import { Reducer } from 'redux';
import { ACTION } from './action-types';
import * as actions from './action-types';
import { mapWireToScheduleDefinition } from './components/schedule-helpers';

export const INITIAL_STATE: CompanyReportState = {
  fetchingReport: false,
  fetchingMetadata: false,
  emails: '',
  emailsValidation: undefined,
  metadata: undefined,
  texts: {} as any,
  validateFilters: false,
  fetchingScheduleDefinition: false,
  scheduleFailedConstraints: undefined,
  scheduleDefinitionChanged: false,
  fetchingSpecialReport: false
};

const reducers: { [indexer: string]: Reducer<CompanyReportState> } = {

  [ACTION.REQUEST_SEND_REPORT]: (state: CompanyReportState, action: actions.RequestSendReport): CompanyReportState => {
    return {
      ...state,
      fetchingReport: true
    };
  },
  [ACTION.RECEIVE_REPORT]: (state: CompanyReportState,
    action: actions.ReceiveReport): CompanyReportState => {
    return {
      ...state,
      fetchingReport: false
    };
  },
  [ACTION.FAILED_TO_SEND_REPORT]: (state: CompanyReportState,
    action: actions.FailedToSendReport): CompanyReportState => {
    return {
      ...state,
      fetchingReport: false
    };
  },
  [ACTION.SET_EMAIL_VALUE]: (state: CompanyReportState, action: actions.SetEmailValue): CompanyReportState => {
    return {
      ...state,
      emails: action.emails,
      emailsValidation: action.validation
    };
  },
  [ACTION.CLEAR_FORM]: (state: CompanyReportState, action: actions.ClearForm): CompanyReportState => {
    return {
      ...state,
      emails: '',
      emailsValidation: undefined,
      metadata: undefined,
      validateFilters: false,
      scheduleFailedConstraints: undefined
    };
  },
  [ACTION.REQUEST_METADATA]: (state: CompanyReportState): CompanyReportState => {
    return {
      ...state,
      fetchingMetadata: true
    };
  },
  [ACTION.RECEIVE_METADATA]: (state: CompanyReportState, action: actions.ReceiveMetadata): CompanyReportState => {
    return {
      ...state,
      fetchingMetadata: false,
      metadata: action.metadata,
      usePredefDate: action.usePredefDate
    };
  },
  [ACTION.VALIDATE_REPORT_FILTERS]: (state: CompanyReportState, action: actions.ValidateReportFilters): CompanyReportState => {
    return {
      ...state,      
      validateFilters: true
    };
  },
  [ACTION.REQUEST_DELETE_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.RequestDeleteScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      fetchingReport: true,
      fetchingScheduleDefinition: true
    };
  },
  [ACTION.RECEIVE_DELETE_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.ReceiveDeleteScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      scheduleDefinition: undefined,
      fetchingReport: false,
      fetchingScheduleDefinition: false
    };
  },
  [ACTION.FAILED_TO_DELETE_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.FailedToDeleteScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      fetchingReport: false
    };
  },
  [ACTION.REQUEST_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.RequestScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      fetchingScheduleDefinition: true
    };
  },
  [ACTION.RECEIVE_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.ReceiveScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      scheduleDefinition: mapWireToScheduleDefinition(action.definition),
      fetchingScheduleDefinition: false
    };
  },
  [ACTION.FAILED_TO_RECEIVE_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.FailedToReceiveScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      scheduleDefinition: undefined,
      fetchingScheduleDefinition: false
    };
  },
  [ACTION.REQUEST_UPDATE_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.RequestUpdateScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      scheduleDefinition: action.definition,
      fetchingScheduleDefinition: true,
      scheduleDefinitionChanged: true
    };
  },
  [ACTION.RECEIVE_UPDATE_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.ReceiveUpdateScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      scheduleDefinitionChanged: false,
      fetchingScheduleDefinition: false,
      scheduleFailedConstraints: action.scheduleFailedConstraints
    };
  },
  [ACTION.FAILED_TO_UPDATE_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.ReceiveUpdateScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      scheduleDefinitionChanged: false,
      fetchingScheduleDefinition: false
    };
  },
  [ACTION.REQUEST_DEFAULT_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.RequestDefaultScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      fetchingScheduleDefinition: true
    };
  },
  [ACTION.RECEIVE_DEFAULT_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.ReceiveDefaultScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      scheduleDefinition: mapWireToScheduleDefinition(action.definition),
      scheduleDefinitionChanged: true,
      fetchingScheduleDefinition: false
    };
  },
  [ACTION.FAILED_TO_RECEIVE_DEFAULT_SCHEDULE_DEFINITION]: (state: CompanyReportState, 
    action: actions.FailedToReceiveScheduleDefinition): CompanyReportState => {
    return {
      ...state,
      scheduleDefinitionChanged: false,
      fetchingScheduleDefinition: false
    };
  },

  [ACTION.REQUEST_CREATE_SPECIAL_REPORT]: (
    state: CompanyReportState,
    action: actions.RequestCreateSpecialReport
  ): CompanyReportState => {
    return {
      ...state,
      fetchingSpecialReport: true
    };
  },

  [ACTION.RECEIVE_CREATE_SPECIAL_REPORT]: (
    state: CompanyReportState,
    action: actions.ReceiveCreateSpecialReport
  ): CompanyReportState => {
    return {
      ...state,
      fetchingSpecialReport: false
    };
  }
};

export const reducer: Reducer<CompanyReportState> = (state: CompanyReportState = INITIAL_STATE, action: any) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
